;(function() {
    var _$wrapper = null,

    init = function() {
        _$wrapper = $('.layout-assign-tablet-ids');


        if (_$wrapper.length > 0) {
            setupAssignLinks();
        }
    },

    //
    // setup the assign links
    //
    setupAssignLinks = function() {
        _$wrapper.find('.lnk-assign').click(function() {
            var $a = $(this);
            var id = $a.attr('data-id');

            //call the server to get the popup content
            ailtire.ajax.get(
                '/assignTabletIDs/popup?id=' + id,
                function(html) {
                    ailtire.popup.open({
                        type: 'confirm',
                        title: 'Assign Tablet ID',
                        content: html,
                        suppressCloseX: true,
                        afterOpen: function($popup) {
                            setTimeout(function() {
                                $popup.find('.modal-body').find('input').focus();
                            }, 300);
                        },
                        okCallback: function($popup) {
                            //create the form data
                            var formData = new FormData();

                            //get the form data
                            $popup.find('.modal-body').find('input').each(function() {
                                var $elem = $(this);
                                formData.append($elem.attr('name'), $elem.val());
                            });

                            //post it
                            ailtire.ajax.postFormData(
                                '/assignTabletIDs/popupSave',
                                formData,
                                function(result) {
                                    if (result.isValid) {
                                        //close the popup
                                        ailtire.popup.close($popup);

                                        //update page values
                                        $a.closest('tr').find('.td-tablet-identifier').html(result.tabletIdentifier);
                                        $a.closest('td').html('');

                                    } else {
                                        //update popup content
                                        $popup.find('.modal-body').html(result.html);
                                    }
                                }
                            )

                            
                            //keep popup open
                            return false;
                        }
                    });
                }
            )

            return false;
        });

    },

    dummy = function(){};

    $(document).ready(init);

})();